import React, { useCallback, useState, useEffect, useContext } from 'react'
import { TenantContext } from '../../tenant/TenantContext';
import { API } from '../../api/API';
import { extractError } from '../../api/ErrorUtil';
import { USER_SPONSORSHIPS, SPONSORSHIPS_URL } from 'config/config';
import { Table, Button, Modal, Row, Col, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileDownload, faTrash, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FormContainer } from 'uiwidgets/FormContainer';
import { FormField } from 'uiwidgets/FormField';
import { SubmitButton } from 'uiwidgets/SubmitButton';
import { formatCurrency } from 'util/Currency';
import { formatDate } from 'util/Date';
import { evenRound } from 'util/NumberUtils';
import { splitCamelCase, camelCase } from 'util/StringUtils';
import { getSponsorshipTypes, getRecipientTypes, getRecurringFrequency, getSponsorshipStatus } from 'util/Lookup';
import _ from "lodash";
import { isDateGreaterThanToday,isFirstDateLesserThanSecondDate } from 'util/Validators';
import { isValidDate } from 'util/Validators';
import { stringToDateEndOfDayUTC,stringUTCToLocalString,addOneYear } from 'util/Date';

const UserSponsorships = () => {

    const initialState = {
        errors: {},
        infoMessage: "",
        sponsorships: [],
        endDate: ""
    };

    const initialValidityDate = {
        endDateError: false,
        endDateErrMsg: ""
    }
    let [formData, setFormData] = useState(initialState);
    let [formValidityData, setFormValidityData] = useState(initialValidityDate);
    const { businessConfig } = useContext(TenantContext);
    const [processingSponsorshipId, setProcessingSponsorshipId] = useState(null);


    const onToastClose = () => {
        setFormData({
            ...formData,
            infoMessage: "",
            errors: {}
        });
    }

    const [showSponsorshipContent, setShowSponsorshipContent] = useState({ show: false, sponsorship:{}, contents: [] });
    const handleSponsorshipContentClose = () => {
        fetchUserSponsorships();
        setShowSponsorshipContent({ show: false, contents: [] });
    }
    const handleSponsorshipContentShow = async (sponsorship) => {
        try {
            let spContentResp = await API.get(SPONSORSHIPS_URL + "/" + sponsorship.sponsorshipId + "/content");
            setShowSponsorshipContent({ show: true, contents: spContentResp.data, sponsorship: sponsorship });
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setShowSponsorshipContent({ show: true, contents: [], sponsorship: sponsorship });
                setFormData({ ...formData, errors: {} });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }
    }

    const [showSponsorshipRenewal, setShowSponsorshipRenewal] = useState({ show: false, sponsorship: {endDate:""} });
    const handleSponsorshipRenewalClose = () => {
        setShowSponsorshipRenewal({ show: false, sponsorship: {} });
    }
    const handleSponsorshipRenewalShow = async (sponsorship) => {
        setFormData({
            ...formData,
            endDate: addOneYear(stringUTCToLocalString(sponsorship.endDate))
        })
        setShowSponsorshipRenewal({ show: true, sponsorship: sponsorship });
    }
    const fetchUserSponsorships = useCallback(async () => {
        try {
            let userSponsorships = await API.get(USER_SPONSORSHIPS);
            setFormData({
                ...formData,
                sponsorships: userSponsorships.data
            })
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setFormData({ ...formData, sponsorships: [], infoMessage: "No sponsorships were found" });
            } else {
                setFormData({ ...formData, sponsorships: [], errors: { message, errors, httpStatus } });
            }
        }
    })

    useEffect(() => {
        fetchUserSponsorships();
    }, []);

    const [showRecipientDetails, setShowRecipientDetails] = useState({ show: false, sponsorship: {} });
    const handleRecipientDetailsClose = () => setShowRecipientDetails({ show: false, sponsorship: {} });
    const handleRecipientDetailsShow = (sponsorship) => {
        setShowRecipientDetails({ show: true, sponsorship: sponsorship });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
    }

    const deleteSponsorship = async (event, sponsorship) => {

        let deleteSponsorship = window.confirm("Are you sure you want to delete the sponsorship. This will remove your recurring payment and will reopen sponsoship for this recipient");
        if (deleteSponsorship) {
            try {
                let resp = await API.delete(USER_SPONSORSHIPS + "/" + sponsorship.sponsorId);
                let userSponsorships = await API.get(USER_SPONSORSHIPS);
                setFormData({
                    ...formData,
                    sponsorships: userSponsorships.data,
                    infoMessage: resp?.data?.message
                })

            }
            catch (error) {
                let { message, errors, httpStatus } = extractError(error);
                if (httpStatus === 404) {
                    setFormData({ ...formData, sponsorships: [], infoMessage: "No sponsorships were found" });
                } else {
                    setFormData({ ...formData, errors: { message, errors, httpStatus } });
                }
            }
        }

    }
    const downloadSponsorshipContent = async (evt, spsContent) => {
        evt.preventDefault();
        await API.get(SPONSORSHIPS_URL + "/content/" + spsContent.id + "/download", { responseType: "blob" })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", camelCase(spsContent.title) + ".pdf");
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                let { message, errors, httpStatus } = extractError(err);
                if (httpStatus === 404) {
                    setFormData({ ...formData, infoMessage: "No sponsorship documents were found" });
                } else {
                    setFormData({ ...formData, errors: { message, errors, httpStatus } });
                }
            });
    }

    const renewSponsorship = async (evt, sponsorship) => {

        try {
            evt.preventDefault();
            let { hasError, error } = validateInput("endDate", formData.endDate, stringUTCToLocalString(sponsorship.endDate));
            if (hasError) {
                setFormValidityData({
                    ...formValidityData,
                    endDateError: hasError,
                    endDateErrMsg: error
                })
                return;
            }
            //call API
            setProcessingSponsorshipId(sponsorship.id);
            await API.put(USER_SPONSORSHIPS + "/" + sponsorship.sponsorId, {
                endDate: stringToDateEndOfDayUTC(formData.endDate)
            });
            let userSponsorships = await API.get(USER_SPONSORSHIPS);
            setFormData({
                ...formData,
                sponsorships: userSponsorships.data,
                infoMessage: "Sponsorship was renewed successfully."
            })

            setProcessingSponsorshipId(null)
            handleSponsorshipRenewalClose();
        } catch (error) {
            setProcessingSponsorshipId(null)
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setFormData({ ...formData, errors: { message: "Sponsorship was not found!" } });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }
    }

    const handleSponsorshipEndDateChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handlSponsorshipEndDateFormValidation = async (event, endDate) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value, endDate);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value, endDate) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "endDate":
                if (value.trim() === "") {
                    hasError = true;
                    error = "End Date cannot be empty";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "End Date is invalid"
                } else if (!isDateGreaterThanToday(value)) {
                    hasError = true;
                    error = "End Date must be greater than todays date"
                } else if (endDate && !isFirstDateLesserThanSecondDate(endDate, value)) {
                    hasError = true;
                    error = "End Date must be greater than current end date"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            default:
                break;
        }
        return { hasError, error };
    }

    return (
        <React.Fragment>
            <FormContainer title="My Sponsorships" submitButtonFunction={handleSubmit} toastCloseFunc={onToastClose}
                errors={formData.errors} infoMessage={formData.infoMessage}>
                <Table className="table-hover table-striped">
                    <thead>
                        <tr>
                            <th> Title</th>
                            <th className="border-0">Amount</th>
                            <th className="border-0">Sponsorship Date</th>
                            <th className="border-0">End Date</th>
                            <th className="border-0">Frequency</th>
                            <th className="border-0">Sponsorship Type</th>
                            <th className="border-0">Recipient Type</th>
                            <th className="border-0">Status</th>
                            <th className="border-0">Recipient Code</th>
                            <td className="border-0">Documents</td>
                            <td className="border-0">Renew Sponsorship</td>
                            <th className="border-0" width="200px">Delete Sponsorhip</th>
                        </tr>

                    </thead>
                    <tbody>
                        {formData.hasOwnProperty('sponsorships') && formData.sponsorships.map((sponsorship, idx) => {
                            let rowStyle = {};
                            if (sponsorship.status === 'PENDING_APPROVAL'){
                                rowStyle = { backgroundColor: '#D3D3D3', color: '#ffffff', pointerEvents: 'none', cursor: 'not-allowed' };
                            }

                            return (
                                <tr key={idx} style={rowStyle}>
                                    <td>{sponsorship.title}</td>
                                    <td>{formatCurrency(evenRound(sponsorship.amountSponsored / 100, 2), businessConfig.locale, businessConfig.currency)}</td>
                                    <td>{formatDate(sponsorship.sponsorshipDate)}</td>
                                    <td>{formatDate(sponsorship.endDate)}</td>
                                    <td>{getRecurringFrequency(sponsorship.frequency)}</td>
                                    <td>{getSponsorshipTypes(sponsorship.sponsorshipType)}</td>
                                    <td>{getRecipientTypes(sponsorship.recipientType)}</td>
                                    <td>{getSponsorshipStatus(sponsorship.status)}</td>
                                    <td>
                                        <Button variant="link" className="border-0 text-dark" onClick={evt => handleRecipientDetailsShow(sponsorship)}>
                                            {sponsorship.sponsorshipAttributes[Object.keys(sponsorship.sponsorshipAttributes)[0]]}
                                        </Button>
                                    </td>
                                    <td>
                                        {sponsorship.hasContent && <Button variant="dark" className="border-0 text-dark" onClick={event => handleSponsorshipContentShow(sponsorship)}>
                                            <FontAwesomeIcon icon={faFilePdf} />
                                        </Button>}
                                    </td>
                                    <td>
                                        {(processingSponsorshipId === sponsorship.id) ? (
                                            <Spinner
                                                style={{ marginBottom: 27 }}
                                                animation="border"
                                                variant="success"
                                            />) : (<>
                                                {/*!isDateGreaterThanToday(formatDate(sponsorship.endDate)) && */}
                                                <Button variant="dark" className="border-0 text-dark" onClick={event => handleSponsorshipRenewalShow(sponsorship)}>
                                                    <FontAwesomeIcon icon={faRefresh} />
                                                </Button>
                                            </>)}

                                    </td>
                                    <td>
                                        {sponsorship.status === 'SPONSORED' && sponsorship.sponsorshipType === 'RECURRING' && <Button variant="dark" className="border-0 text-dark" onClick={evt => deleteSponsorship(evt, sponsorship)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Button>}
                                        {sponsorship.status === 'FULFILLED' && <>Sponsorship was fulfilled and support is no longer required.</>}
                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <Modal show={showRecipientDetails.show} onHide={handleRecipientDetailsClose}>
                    <Modal.Header closeButton />
                    <Modal.Body>
                        <Table>
                            <tbody>
                                <tr>
                                    {showRecipientDetails.sponsorship?.mediaType &&
                                        <td>
                                            <img src={process.env.REACT_APP_BASE_API_URL + SPONSORSHIPS_URL + '/' + showRecipientDetails.sponsorship.sponsorshipId + '/img'} />
                                        </td>}

                                    <td>
                                        {showRecipientDetails.sponsorship.sponsorshipAttributes && Object.entries(showRecipientDetails.sponsorship.sponsorshipAttributes).map(([key, value]) => (
                                            <React.Fragment key={key}>
                                                <strong key={key}>{splitCamelCase(key)}:</strong> {value} <br />
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
                <Modal show={showSponsorshipContent.show} onHide={handleSponsorshipContentClose}>
                    <Modal.Header closeButton><b>Sponsorship Documents</b></Modal.Header>
                    <Modal.Body>
                        {showSponsorshipContent.contents && showSponsorshipContent.contents.map((content, idx) => (
                            <Row key={idx}><Col>
                                <Button variant="dark" className="border-0 text-dark" onClick={event => { downloadSponsorshipContent(event, content) }}>
                                    <FontAwesomeIcon icon={faFileDownload} />&nbsp;{content.title}
                                </Button>
                            </Col>
                            </Row>
                        ))}
                    </Modal.Body>
                </Modal>
                <Modal show={showSponsorshipRenewal.show} onHide={handleSponsorshipRenewalClose}>
                    <Modal.Header closeButton><b>Sponsorship Renewal</b></Modal.Header>
                    <Modal.Body>
                        <FormContainer title="Renew Sponsorship"
                            submitButtonFunction={event => renewSponsorship(event, showSponsorshipRenewal.sponsorship)}>
                            <Row>
                                <Col sm={12} mb={6} lg={6}>
                                    <FormField name="endDate" label="Sponsorship End Date" type="date" value={formData.endDate}
                                        placeholder="Sponsorship End Date" onChange={handleSponsorshipEndDateChange} onBlur={(event)=>handlSponsorshipEndDateFormValidation(event, stringUTCToLocalString(showSponsorshipRenewal.sponsorship?.endDate))}
                                        valstate={!formValidityData.endDateError} valMsg={formValidityData.endDateErrMsg}
                                        readOnly={formData.readOnly} />
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <SubmitButton label="Renew Sponsorship" />
                                </Col>
                            </Row>
                        </FormContainer>

                    </Modal.Body>
                </Modal>
            </FormContainer>
        </React.Fragment>
    )
}

export default UserSponsorships